<template>
  <div class="svs-logo">
    <svg
      width="71"
      height="98"
      viewBox="0 0 71 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        class="svs-logo__path--main"
        d="M38 0H7C3.134 0 0 3.134 0 7V91C0 94.866 3.134 98 7 98H64C67.866 98 71 94.866 71 91V33L38 0Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        class="svs-logo__path--secondary"
        d="M38 0V25.9937C38 29.8596 41.134 32.9937 45 32.9937H70.9937L38 0Z"
      />
    </svg>

    <div class="svs-logo__dot-flashing" />
  </div>
</template>

<script>
export default {
  name: 'SvsLoading',

  props: {
    color: {
      type: String,
      required: false,
      default: 'black'
    }
  }
}
</script>

<style scoped lang="scss">
  $dot-color: white;

  .svs-logo {
    position: relative;

    &__path {
      &--main {
        fill: $color-secondary;
      }

      &--secondary {
        fill: #427bc1;
      }
    }

    &__dot-flashing {
      position: absolute;
      bottom: 31px;
      left: 50%;
      transform: translateX(-50%) scale(1.1);
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: $dot-color;
      color: $dot-color;
      animation: dot-flashing 0.5s infinite linear alternate;
      animation-delay: 0.25s;

      &::before, &::after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
      }

      &::before {
        left: -15px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: $dot-color;
        color: $dot-color;
        animation: dot-flashing 0.5s infinite alternate;
        animation-delay: 0s;
      }

      &::after {
        left: 15px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: $dot-color;
        color: $dot-color;
        animation: dot-flashing 0.5s infinite alternate;
        animation-delay: 0.5s;
      }
    }
  }

  @keyframes dot-flashing {
    0% {
      background-color: $dot-color;
    }
    50%, 100% {
      background-color: rgba($dot-color, 0.2);
    }
  }
</style>
